import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

/**
 * Generic function for push the GTM data
 * @param e
 * @param event
 * @param content_type
 */
function datalayerPushGeneric(e, event, content_type, title_text, click_text) {
  const module = e.target.closest('section');
  if (!e || !module) return false;

  const bulletIndex = e.target.dataset.auSliderBulletIndex;
  // we get title from some of this selectors. If any doesn't exist, we get the next one
  const title =
    module.querySelector(`[data-swiper-slide-index="${bulletIndex}"] [data-au-title]`) || // for sliders with loop
    module.querySelector('.au-active [data-au-title], .swiper-slide-active [data-au-title]') || // for tabs or sliders without loop, or any content that is showed by adding au-active class
    module.querySelector('[data-au-title]') || // title of card, article, etc
    module.querySelector('[data-au-heading-title]'); // title of heading

  const headingTitle = module.querySelector('[data-au-heading-title]');

  const elementHasIcon = e.target.querySelector('[data-au-icon]'),
    isInsideTabContent = e.target.closest('[data-au-tab-content]'),
    isInsideTabs = e.target.closest('[data-au-featured-card'),
    isInsideAccordionSection = e.target.closest('[data-au-accordion-section]');

  let clickText, titleText;

  if (title_text) {
    titleText = title_text;
  } else if (isInsideTabContent && !isInsideAccordionSection) {
    const tabContentId = isInsideTabContent.getAttribute('data-au-tab-content');
    const tab = document.querySelector(`[data-au-tab=${tabContentId}]`);
    tab.childNodes.forEach((value) => {
      if (value.nodeType === Node.TEXT_NODE) titleText = value.nodeValue;
    });
  } else if ((isInsideTabs && headingTitle) || e.target.closest('.au-heading')) {
    titleText = headingTitle ? headingTitle.innerText : '';
  } else {
    titleText = title ? title.innerText : '';
  }
  titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;

  if (click_text) {
    clickText = click_text;
  } else if (elementHasIcon) {
    if (e.target.querySelector(':not([data-au-icon])')) {
      clickText = e.target.querySelector(':not([data-au-icon])').innerText;
    } else {
      e.target.childNodes.forEach((value) => {
        if (value.nodeType === Node.TEXT_NODE) clickText = value.nodeValue;
      });
    }
  } else {
    clickText = e.target.innerText;
  }
  clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;

  const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;
  const event_text = event || 'navigation';
  const contentTypeText = {
    button: 'clickBoton',
    link: 'clickEnlace',
    download: 'clickDescarga',
    card: 'clickCard',
    tab: 'clickTab',
    video: 'clickVideo',
    slider: 'clickSlider',
    email: 'clickEmail',
    phone: 'clickTelefono',
  };

  const content_type_text = contentTypeText[e.target.dataset.auDatalayer] || '';

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: event_text,
    content_type: content_type || content_type_text,
    item_id,
  });
}

export default datalayerPushGeneric;
